import service from "@/store/services/tags-service";

const state = {
  list: {},
  tag: {},
  meta: {},
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, tag) => {
    state.tag = tag;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service
      .list(params)
      .then(({ list, meta }) => {
        commit("SET_LIST", list);
        commit("SET_META", meta);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  get({ commit, dispatch }, params) {
    return service
      .get(params)
      .then((tag) => {
        if (tag.hasOwnProperty("data") && tag.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              tag.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", tag);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  add({ commit, dispatch }, params) {
    return service
      .add(params)
      .then((tag) => {
        if (tag.hasOwnProperty("data") && tag.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              tag.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", tag);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  update({ commit, dispatch }, params) {
    return service
      .update(params)
      .then((tag) => {
        if (tag.hasOwnProperty("data") && tag.data.error) {
          commit("SET_ERROR_BIT", true, { root: true });
          commit(
            "SET_ERROR_INFO",
            "<br>" +
              "Server responded with error = True <br> errorCode: " +
              tag.data.errorCode,
            { root: true }
          );
        }
        commit("SET_RESOURCE", tag);
      })
      .catch((err) => {
        commit("SET_ERROR_BIT", true, { root: true });
        commit("SET_ERROR_INFO", err.stack, { root: true });
      });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  tag: (state) => state.tag,
  dropdown: (state) => {
    return state.list.map((tag) => ({
      id: tag.id,
      name: tag.name,
    }));
  },
};

const tags = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default tags;
